/* lunalume-set · Set-Baukasten "Ihr Set gestalten" (02.10.2026, Befunde 03.10.2026 eingearbeitet)
 *
 * Liest die Daten, die Liquid als JSON in die Seite schreibt (<script type="application/json" data-ll-bk-daten>),
 * und fuehrt den Baukasten: Baldachin waehlen (Radiogruppe), Schirme auf die Auslaesse verteilen (Draufsicht bzw.
 * freie Reihe), Licht und Strom (Zeilen aus Liquid), Zusammenfassung, "Set in den Warenkorb".
 *
 * Regeln, die hier gelten (siehe ZUSTAENDE.md):
 *  - Summe der Einzelpreise der VERFUEGBAREN Positionen (= was in den Warenkorb geht), keine Knappheit, keine
 *    Vorauswahl eines Baldachins. Nicht verfuegbare Schirme stehen als "Nicht verfuegbar" in der Liste, ohne Preis,
 *    und zaehlen nicht (Befund 03.10.: angezeigt 119 EUR, im Korb 89 EUR).
 *  - Mengenrabatt (R5, 04.10.2026, Auftrag Ilyas "den sale rabatt der soll direkt angezeigt werden"): ab der Staffel
 *    der Theme-Leiste (Katalog mengenrabatt_staffel, 3/6/9 -> 5/10/15 %) Zwischensumme, "Mengenrabatt (n Artikel ·
 *    p %)" mit Abzug und Summe = Endbetrag; Rundung je Position wie der Bot-Warenkorb (allocation 'each'). Anreiz
 *    nur mit der echten naechsten Stufe und nur, wenn die freien Plaetze reichen; keine Knappheit, kein Zeitdruck.
 *    Warenkorb zaehlt mit (Pruefung 3, 04.10. abends, Befund MITTEL): Shopify zaehlt fuer die Stufe ALLE Artikel im
 *    Warenkorb. Schirme/Baldachine, die schon drin liegen, zaehlen hier mit ("n Artikel inkl. k im Warenkorb"; Abzug =
 *    Anteil des Sets). Start aus Liquid (data korb = cart.items, keine Anfrage), danach cart:change (Inhalt im Ereignis)
 *    bzw. cart:refresh/pageshow (je EIN Abruf, nie eine Schleife). Andere Artikel (Regel nicht lesbar, B10) zaehlen
 *    nicht -> statt Anreiz "Weitere Artikel im Warenkorb sind hier nicht eingerechnet."; Warenkorb unbekannt -> kein Anreiz.
 *  - Streichpreise (Baldachine, Schirm-Karten) nur bei compare_at > Preis (Akku-Baldachin 35 < 36: keiner).
 *  - Ein Platz ist {h: Handle, v: Varianten-ID}. Platz 1 = dieser Schirm in der Variante der Seite (aktuellV);
 *    wechselt das Kaufformular die Variante (Impact 'variant:change'), zieht der Platz mit. Ab zwei Varianten bietet
 *    die Schublade je Karte eine Auswahl; nicht verfuegbare Varianten/Schirme sind deaktiviert.
 *  - Zubehoer nur waehlbar im Zustand 2 und nur, wenn jeder gewaehlte Schirm in kabel_passt steht; sonst
 *    allgemeiner Hinweis ohne Passungsaussage. Den Startzustand entscheidet Liquid; hier nur Aenderungen.
 *    Mengen starten bei 0 (vorbelegen = false, § 312a Abs. 3 BGB).
 *  - leuchten_je_netzteil gibt es hier bewusst nicht: keine Rechnung, keine Aussage.
 *  - Vorschau-Modus (lunalume-vorschau.js hat die Zeilen ersetzt): Zubehoer nie im Warenkorb.
 *  - Schublade (Impact x-drawer): Startfokus ueber initial-focus="... [data-ll-bk-fokus]" — das Attribut setzt
 *    schubladeOeffnen() vor dem Oeffnen auf die gewaehlte Karte bzw. den aktiven Filter.
 *  - Entfernen (03.10., Auftrag Ilyas "Schirme wieder entfernen"): jeder belegte Platz traegt einen sichtbaren
 *    Knopf x (aria-label "Schirm von Platz n entfernen"), dazu "Platz leeren" in der Schublade. Mit Baldachin wird
 *    der Platz leer (Auslass bleibt), ohne Baldachin faellt er aus der Reihe. Danach Fokus auf den nun leeren Platz
 *    (freie Reihe: "Schirm hinzufuegen"), Ansage in der Live-Region [data-ll-bk-ansage]. Leeres Set: Knopf
 *    deaktiviert, Hinweis [data-ll-bk-knopf-hinweis] sichtbar und per aria-describedby verbunden.
 *  - Baldachinwechsel verlustfrei (Befund HOCH 04.10.): was nicht auf die Auslaesse passt, bleibt in st.abgestellt
 *    (nicht im Set, nicht summiert) und kommt bei mehr Auslaessen oder "Ohne Baldachin" zurueck. Hinweis mit Namen
 *    direkt unter der Radiogruppe ([data-ll-bk-abgestellt], role=status), bis alle wieder gesetzt sind.
 *  - Warenkorb: POST /cart/add.js mit items[] (nur verfuegbare Varianten), Abschnitte gebuendelt wie Impacts
 *    product-form; danach cart:change (Schubfach + Zaehler sofort) bzw. cart:refresh als Rueckfall,
 *    product:added-to-cart (Mengenleiste), Schubfach #cart-drawer oeffnen. Ist add.js ok, steht IMMER "Im Warenkorb.";
 *    cart.js danach nur mit r.ok, sonst cart:refresh (Pruefung 3: 429 auf cart.js meldete einen Fehler, obwohl das Set
 *    im Korb lag — ein zweiter Klick verdoppelte es). Waehrend der Anfrage aria-disabled +
 *    aria-busy statt disabled (Fokus bleibt auf dem Knopf, Befund MITTEL 04.10.).
 *  - Fokusziele bekommen Abstand zu Impacts fester Kaufleiste (--ll-leiste, Befund MITTEL 04.10., WCAG 2.4.11).
 *
 * Die reine Logik (Logik.*) hat keinen DOM-Bezug und wird in Node getestet (set_baukasten/test_set_logik.js).
 */
(function () {
  'use strict';

  var Logik = (function () {
    var RING = 0.68;   // Auslass-Ring : Aussendurchmesser — nur Darstellung (Verhaeltnis, keine mm-Angabe)

    function text(vorlage, werte) {
      return String(vorlage == null ? '' : vorlage).replace(/\{(\w+)\}/g, function (ganz, k) {
        return werte && werte[k] != null ? String(werte[k]) : ganz;
      });
    }

    function teile(cent, stellen, tausender, dezimal) {
      var fest = (Math.abs(cent) / 100).toFixed(stellen).split('.');
      var ganz = fest[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausender);
      return (cent < 0 ? '-' : '') + ganz + (fest[1] ? dezimal + fest[1] : '');
    }

    /* Shopify-Geldformat ({{amount_with_comma_separator}} usw.), Betrag in Cent */
    function geld(cent, format) {
      var c = Math.round(Number(cent) || 0);
      var f = String(format || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (ganz, art) {
        switch (art) {
          case 'amount': return teile(c, 2, ',', '.');
          case 'amount_no_decimals': return teile(c, 0, ',', '.');
          case 'amount_no_decimals_with_comma_separator': return teile(c, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return teile(c, 2, '\'', '.');
          case 'amount_with_space_separator': return teile(c, 2, ' ', ',');
          default: return teile(c, 2, '.', ',');
        }
      });
    }

    /* n Auslaesse gleichmaessig auf dem Ring, Start oben (-90 Grad); x/y in Prozent der Flaeche */
    function punkte(n, ring) {
      var r = (ring == null ? RING : ring) * 50, aus = [];
      for (var i = 0; i < n; i++) {
        var w = -Math.PI / 2 + i * 2 * Math.PI / n;
        aus.push({ x: Math.round((50 + r * Math.cos(w)) * 1000) / 1000, y: Math.round((50 + r * Math.sin(w)) * 1000) / 1000 });
      }
      return aus;
    }

    /* Plaetze auf n Auslaesse bringen (n null = freie Reihe, hoechstens max Plaetze). Belegte Plaetze behalten ihre
       Stelle; was ueber n hinausgeht, rueckt in freie Plaetze nach. Was dann noch uebrig ist, geht NICHT verloren,
       sondern kommt als rest zurueck (Befund HOCH 04.10.). Gibt neue Listen zurueck, die Eingabe bleibt. */
    function plaetzeAnpassen(plaetze, n, max) {
      var alt = (plaetze || []).slice();
      if (n == null) {
        var voll = alt.filter(Boolean);
        var grenze = max > 0 ? Math.min(max, voll.length) : voll.length;
        return { plaetze: voll.slice(0, grenze), rest: voll.slice(grenze) };
      }
      var neu = [];
      for (var i = 0; i < n; i++) neu.push(alt[i] || null);
      var rest = [];
      alt.slice(n).filter(Boolean).forEach(function (e) {
        var j = neu.indexOf(null);
        if (j === -1) rest.push(e);
        else neu[j] = e;
      });
      return { plaetze: neu, rest: rest };
    }

    /* Baldachin wechseln, ohne Schirme zu verlieren (Befund HOCH 04.10.: in der Radiogruppe waehlt jede Pfeiltaste
       sofort aus; der Weg "Ohne" -> 5-fach fuehrt ueber 3-fach und verwarf dabei zwei Schirme endgueltig).
       Abgestellte Schirme stehen hinter den Plaetzen und ruecken wie Ueberlauf in freie Auslaesse; was nicht passt,
       bleibt abgestellt — nicht im Set, nicht in Summe und Warenkorb, aber gemerkt. Liefert neue Listen:
       {plaetze, abgestellt, neu: jetzt neu abgestellt, wieder: wieder eingesetzt}. */
    function baldachinWechsel(plaetze, abgestellt, n, max) {
      var vorher = (abgestellt || []).slice();
      var r = plaetzeAnpassen((plaetze || []).concat(vorher), n, max);
      return {
        plaetze: r.plaetze,
        abgestellt: r.rest,
        neu: r.rest.filter(function (e) { return vorher.indexOf(e) === -1; }),
        wieder: vorher.filter(function (e) { return r.rest.indexOf(e) === -1; })
      };
    }

    function belegt(plaetze) {
      return (plaetze || []).filter(Boolean).length;
    }

    /* Platz-Eintrag: {h, v}; Zeichenketten (nur Handle) werden wie {h} behandelt */
    function handleVon(e) {
      return e == null ? null : (typeof e === 'string' ? e : e.h);
    }

    function finde(liste, h) {
      for (var i = 0; i < (liste || []).length; i++) if (liste[i].h === h) return liste[i];
      return null;
    }

    /* Variante eines Schirms; ohne vs (aeltere Daten) die Standardvariante aus v/p/ok */
    function variante(s, v) {
      if (!s) return null;
      var vs = s.vs || [];
      for (var i = 0; i < vs.length; i++) if (Number(vs[i].id) === Number(v)) return vs[i];
      if (v == null || Number(v) === Number(s.v)) return { id: s.v, p: s.p, ok: s.ok !== false, t: '', c: s.c == null ? null : s.c };
      return null;
    }

    function mehrereVarianten(s) {
      return !!(s && s.vs && s.vs.length > 1);
    }

    /* Schirm waehlbar, wenn mindestens eine Variante verfuegbar ist */
    function schirmOk(s) {
      if (!s) return false;
      if (s.vs && s.vs.length) return s.vs.some(function (x) { return x.ok !== false; });
      return s.ok !== false;
    }

    /* Startvariante beim Waehlen: die Standardvariante, wenn verfuegbar, sonst die erste verfuegbare */
    function startVariante(s) {
      if (!s) return null;
      var std = variante(s, s.v);
      if (std && std.ok !== false) return std.id;
      var vs = s.vs || [];
      for (var i = 0; i < vs.length; i++) if (vs[i].ok !== false) return vs[i].id;
      return s.v;
    }

    /* gleiche Schirme (Handle + Variante) zusammenfassen, Reihenfolge des ersten Auftretens */
    function zaehlen(plaetze) {
      var reihe = [], menge = {};
      (plaetze || []).forEach(function (e) {
        if (!e) return;
        var h = handleVon(e), v = typeof e === 'string' ? null : (e.v == null ? null : e.v);
        var k = h + '|' + (v == null ? '' : v);
        if (!menge[k]) { menge[k] = { h: h, v: v, m: 0 }; reihe.push(k); }
        menge[k].m++;
      });
      return reihe.map(function (k) { return menge[k]; });
    }

    /* Namen fuer Hinweis und Ansage: "2 × Crema, Linda (S)" — gleiche Schirme (Handle + Variante) zusammengefasst */
    function namenListe(eintraege, nameVon) {
      return zaehlen(eintraege).map(function (z) {
        var n = nameVon({ h: z.h, v: z.v });
        return z.m > 1 ? z.m + ' × ' + n : n;
      }).join(', ');
    }

    function positionen(st, d, zubehoer) {
      var pos = [];
      if (st.baldachin) {
        var b = finde(d.baldachine, st.baldachin);
        if (b) pos.push({ art: 'baldachin', h: b.h, v: b.v, n: b.n, m: 1, p: b.p, u: b.u, ok: b.ok !== false });
      }
      zaehlen(st.plaetze).forEach(function (z) {
        var s = finde(d.schirme, z.h);
        if (!s) return;
        var va = variante(s, z.v == null ? s.v : z.v) || { id: z.v, p: 0, ok: false, t: '' };
        var mehr = mehrereVarianten(s);
        pos.push({
          art: 'schirm', h: s.h, v: va.id, n: s.n + (mehr && va.t ? ' · ' + va.t : ''), m: z.m, p: va.p,
          u: s.u + (mehr && va.id ? '?variant=' + va.id : ''), ok: va.ok !== false
        });
      });
      (zubehoer || []).forEach(function (z) {
        if (z.m > 0 && z.bestellbar) pos.push({ art: 'zubehoer', h: z.sku, v: z.v, n: z.n, m: z.m, p: z.p, u: z.u, ok: true });
      });
      return pos;
    }

    /* Summe nur der verfuegbaren Positionen — genau das, was posten() in den Warenkorb legt */
    function summe(pos) {
      return (pos || []).reduce(function (s, p) { return p.ok === false ? s : s + p.p * p.m; }, 0);
    }

    /* items[] fuer /cart/add.js: nur verfuegbare Positionen mit Varianten-ID, gleiche IDs zusammengefasst */
    function posten(pos) {
      var reihe = [], menge = {};
      (pos || []).forEach(function (p) {
        if (!p.ok || !p.v || !(p.m > 0)) return;
        var id = Number(p.v);
        if (!menge[id]) { menge[id] = 0; reihe.push(id); }
        menge[id] += p.m;
      });
      return reihe.map(function (id) { return { id: id, quantity: menge[id] }; });
    }

    /* Zubehoerzeilen nur, wenn JEDER gewaehlte Schirm in der Liste steht. Leer = nie (keine Passungsaussage). */
    function kabelPasst(plaetze, liste) {
      var voll = (plaetze || []).filter(Boolean).map(handleVon);
      if (!liste || !liste.length || !voll.length) return false;
      return voll.every(function (h) { return liste.indexOf(h) !== -1; });
    }

    /* Platz i entfernen — gibt eine NEUE Liste zurueck (Eingabe bleibt). Mit Baldachin wird der Platz leer (der Auslass
       bleibt, die anderen behalten ihre Stelle); ohne Baldachin faellt er aus der freien Reihe. Leerer oder
       unbekannter Platz: unveraendert. */
    function platzEntfernen(plaetze, i, mitBaldachin) {
      var neu = (plaetze || []).slice();
      if (!(i >= 0 && i < neu.length) || !neu[i]) return neu;
      if (mitBaldachin) neu[i] = null;
      else neu.splice(i, 1);
      return neu;
    }

    /* Fokus nach dem Entfernen: mit Baldachin der nun leere Platz i; in der freien Reihe gibt es keinen leeren
       Platz, dort ist "Schirm hinzufuegen" die freie Stelle */
    function fokusNachEntfernen(mitBaldachin, i) {
      return mitBaldachin ? i : 'hinzu';
    }

    /* Leeres Set = nichts, was in den Warenkorb ginge (auch: nur nicht verfuegbare Positionen) */
    function setLeer(pos) {
      return posten(pos).length === 0;
    }

    /* Kaufformular wechselt die Variante dieses Schirms: Plaetze mit (h, alt) bekommen neu, andere bleiben */
    function varianteTauschen(plaetze, h, alt, neu) {
      return (plaetze || []).map(function (e) {
        if (e && handleVon(e) === h && Number(e.v) === Number(alt)) return { h: h, v: neu };
        return e;
      });
    }

    function familien(schirme) {
      var aus = [];
      (schirme || []).forEach(function (s) { if (s.f && aus.indexOf(s.f) === -1) aus.push(s.f); });
      return aus;
    }

    function vorschauAktiv(suche, theme) {
      return /(?:^|[?&])zubehoer_vorschau=1(?:&|$)/.test(String(suche || '').replace(/^\?/, '')) &&
        !!theme && typeof theme.role === 'string' && theme.role !== '' && theme.role !== 'main';
    }

    function menge(wert) {
      var n = parseInt(wert, 10);
      if (isNaN(n) || n < 0) return 0;
      return n > 99 ? 99 : n;
    }

    /* ---- Mengenrabatt (R5, 04.10.2026) ----
       Staffel "3:5,6:10,9:15" (ab n Artikeln p Prozent) = Mengenrabatt-Leiste des Themes (snippets/volume-goal-bar),
       im Set-Katalog als Daten gefuehrt. Unlesbare Stufen fallen weg, Ergebnis aufsteigend nach ab. */
    function staffel(text) {
      var aus = [];
      String(text || '').split(',').forEach(function (teil) {
        var m = /^\s*(\d+)\s*:\s*(\d+(?:\.\d+)?)\s*$/.exec(teil);
        if (!m) return;
        var ab = parseInt(m[1], 10), p = parseFloat(m[2]);
        if (ab > 0 && p > 0 && p < 100) aus.push({ ab: ab, p: p });
      });
      return aus.sort(function (a, b) { return a.ab - b.ab; });
    }

    /* hoechste erreichte Stufe fuer n Artikel, sonst null */
    function rabattStufe(n, st) {
      var treffer = null;
      (st || []).forEach(function (s) { if (n >= s.ab) treffer = s; });
      return treffer;
    }

    /* naechste Stufe ueber n: {ab, p, fehlt}, sonst null */
    function naechsteStufe(n, st) {
      var liste = st || [];
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].ab > n) return { ab: liste[i].ab, p: liste[i].p, fehlt: liste[i].ab - n };
      }
      return null;
    }

    /* Prozent eines Cent-Betrags, auf ganze Cent gerundet (halbe Cent auf) */
    function prozentVon(cent, p) {
      return Math.round(cent * p / 100);
    }

    /* Mengenrabatt eines Sets. Gezaehlt werden die verfuegbaren Positionen (Baldachin und Schirme immer, Zubehoer nur
       mit opt.zubehoer — Katalog rabatt_zaehlt). Der Abzug trifft genau die gezaehlten Positionen.
       opt.korb = Artikel, die SCHON im Warenkorb liegen und sicher mitzaehlen (korbZaehlen().set; Pruefung 3,
       04.10. abends: Shopify zaehlt fuer die Stufe ALLE Artikel im Warenkorb). Die Stufe gilt fuer Set + Warenkorb,
       der Abzug bleibt der Anteil des Sets.
       Rundung wie Shopify (Bot-Warenkorb 04.10.2026: automatischer Rabatt "5%", allocation_method 'each' — je
       Warenkorb-Zeile p % des Zeilenpreises, auf Cent gerundet): opt.rundung 'position' (Standard) rundet je
       Position (Zeilenpreis = Preis x Menge), 'summe' einmal auf die Summe.
       Liefert {anzahl (Set), korb, gesamt, stufe, zwischensumme, betrag, summe, naechste}; ohne Staffel betrag 0,
       leeres Set ohne Stufe. */
    function mengenrabatt(pos, st, opt) {
      var o = opt || {};
      var zwischensumme = summe(pos);
      var gezaehlt = (pos || []).filter(function (x) {
        return x.ok !== false && x.m > 0 && (x.art !== 'zubehoer' || !!o.zubehoer);
      });
      var anzahl = gezaehlt.reduce(function (s, x) { return s + x.m; }, 0);
      var korb = Math.max(0, Math.floor(Number(o.korb) || 0));
      var gesamt = anzahl + korb;
      var stufe = anzahl > 0 ? rabattStufe(gesamt, st) : null;
      var betrag = 0;
      if (stufe) {
        if (o.rundung === 'summe') {
          betrag = prozentVon(gezaehlt.reduce(function (s, x) { return s + x.p * x.m; }, 0), stufe.p);
        } else {
          betrag = gezaehlt.reduce(function (s, x) { return s + prozentVon(x.p * x.m, stufe.p); }, 0);
        }
      }
      return {
        anzahl: anzahl, korb: korb, gesamt: gesamt, stufe: stufe, zwischensumme: zwischensumme, betrag: betrag,
        summe: zwischensumme - betrag, naechste: naechsteStufe(gesamt, st)
      };
    }

    /* Handle aus einer Produkt-URL ("/products/<handle>?..." -> "<handle>"), sonst '' */
    function handleAusUrl(u) {
      var teil = String(u || '').split('/products/')[1];
      return teil ? teil.split(/[?#\/]/)[0] : '';
    }

    /* Handles, deren Artikel im Warenkorb SICHER fuer die Staffel mitzaehlen: Schirme und Baldachine des Baukastens
       (Bot-Warenkorb 04.10.: beide zaehlen), Zubehoer (aus den Zeilen-URLs) nur mit zubehoer = Katalog rabatt_zaehlt.
       Die Rabattregel selbst ist nicht lesbar (B10) — alles andere gilt als 'fremd' und wird nicht eingerechnet. */
    function rabattHandles(d, zubehoer, urls) {
      var m = {};
      ((d && d.schirme) || []).forEach(function (s) { if (s && s.h) m[s.h] = true; });
      ((d && d.baldachine) || []).forEach(function (b) { if (b && b.h) m[b.h] = true; });
      if (zubehoer) (urls || []).forEach(function (u) { var h = handleAusUrl(u); if (h) m[h] = true; });
      return m;
    }

    /* Warenkorb-Posten zaehlen: items = [{h, m}] (Liquid) oder cart.js-Zeilen [{handle, quantity}].
       Liefert {set: Artikel mit Handle in handles, fremd: alle anderen} */
    function korbZaehlen(items, handles) {
      var set = 0, fremd = 0, h2 = handles || {};
      (items || []).forEach(function (i) {
        if (!i) return;
        var m = Math.floor(Number(i.m != null ? i.m : i.quantity) || 0);
        if (m <= 0) return;
        var h = i.h != null ? i.h : i.handle;
        if (h && Object.prototype.hasOwnProperty.call(h2, h)) set += m; else fremd += m;
      });
      return { set: set, fremd: fremd };
    }

    /* Streichpreis nur, wenn der Vergleichspreis (compare_at) WIRKLICH hoeher ist (Akku-Baldachin: 35 < 36 -> keiner) */
    function streichpreis(p, c) {
      return c != null && Number(c) > Number(p) ? Number(c) : null;
    }

    /* Prozentzahl deutsch: 5 -> "5", 7.5 -> "7,5" */
    function prozentText(p) {
      return String(p).replace('.', ',');
    }

    return {
      RING: RING, text: text, geld: geld, punkte: punkte, plaetzeAnpassen: plaetzeAnpassen, belegt: belegt,
      baldachinWechsel: baldachinWechsel, namenListe: namenListe,
      handleVon: handleVon, zaehlen: zaehlen, finde: finde, variante: variante, mehrereVarianten: mehrereVarianten,
      schirmOk: schirmOk, startVariante: startVariante, positionen: positionen, summe: summe, posten: posten,
      kabelPasst: kabelPasst, varianteTauschen: varianteTauschen, familien: familien, vorschauAktiv: vorschauAktiv,
      menge: menge, platzEntfernen: platzEntfernen, fokusNachEntfernen: fokusNachEntfernen, setLeer: setLeer,
      staffel: staffel, rabattStufe: rabattStufe, naechsteStufe: naechsteStufe, prozentVon: prozentVon,
      mengenrabatt: mengenrabatt, streichpreis: streichpreis, prozentText: prozentText,
      handleAusUrl: handleAusUrl, rabattHandles: rabattHandles, korbZaehlen: korbZaehlen
    };
  })();

  if (typeof module === 'object' && module.exports) {
    module.exports = Logik;
    return;
  }
  window.LunalumeSetLogik = Logik;

  /* ================================================================ Seite */
  var L = Logik;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[c];
    });
  }

  function geldFormat() {
    var tv = (window.themeVariables && window.themeVariables.settings) || {};
    var f = tv.currencyCodeEnabled ? tv.moneyWithCurrencyFormat : tv.moneyFormat;
    var ta = document.createElement('textarea');
    ta.innerHTML = f || '';
    return ta.value || '{{amount_with_comma_separator}} €';
  }

  function lichtAn() {
    return document.documentElement.getAttribute('data-licht') === 'an';
  }

  function wurzelPfad() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Warenkorb EINMAL lesen (nur auf Anlass: cart:refresh, pageshow aus dem Cache, nach "Set in den Warenkorb"; nie in
     einer Schleife). Eine laufende Anfrage wird geteilt — ausser mit frisch (nach add.js: eine vor dem Hinzufuegen
     gestartete Anfrage wuerde den alten Korb liefern). Liefert den Warenkorb oder null (429/HTML/Netz) — wirft nie. */
  var korbAnfrage = null;
  function korbLesen(frisch) {
    if (korbAnfrage && !frisch) return korbAnfrage;
    var anfrage = fetch(wurzelPfad() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (korb) {
        if (korbAnfrage === anfrage) korbAnfrage = null;
        return korb && Array.isArray(korb.items) ? korb : null;
      });
    korbAnfrage = anfrage;
    return anfrage;
  }

  function bildHtml(paar, breite) {
    var aus = paar && paar[0] ? paar[0] : '';
    var an = paar && paar[1] ? paar[1] : '';
    if (!aus) return '<span class="ll-bk-bild"></span>';
    var src = lichtAn() && an ? an : aus;
    return '<span class="ll-bk-bild" data-lunalume-bilder="' + esc(aus) + ',,' + esc(an) + '"><img src="' + esc(src) +
      '" alt="" width="' + breite + '" height="' + breite + '" loading="lazy" decoding="async"></span>';
  }

  function sichtbar(el) {
    return !!el && !el.disabled && !el.closest('[hidden]');
  }

  var PLATZ_GROESSE = { 1: 30, 2: 28, 3: 27, 4: 25, 5: 23, 6: 21, 7: 19, 8: 18, 9: 17 };
  var X_SVG = '<svg aria-hidden="true" focusable="false" width="10" height="10" viewBox="0 0 10 10">' +
    '<path d="M1.5 1.5l7 7m0-7l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function Baukasten(el) {
    this.el = el;
    this.d = JSON.parse(el.querySelector('[data-ll-bk-daten]').textContent);
    this.t = this.d.texte || {};
    this.format = geldFormat();
    this.st = { baldachin: null, plaetze: [], abgestellt: [], filter: '', platz: 0, kabelManuell: false };
    var akt = L.finde(this.d.schirme, this.d.aktuell);
    this.aktuellV = this.d.aktuellV || (akt ? akt.v : null);
    if (akt) this.st.plaetze = [{ h: akt.h, v: this.aktuellV }];
    this.plan = el.querySelector('[data-ll-bk-plan]');
    this.zaehler = el.querySelector('[data-ll-bk-zaehler]');
    this.liste = el.querySelector('[data-ll-bk-liste]');
    this.summeEl = el.querySelector('[data-ll-bk-summe]');
    /* R5 Mengenrabatt: Staffel/Zaehlweise/Rundung aus dem Set-Katalog (null = Katalog mengenrabatt_zeile 'aus') */
    this.rabatt = this.d.rabatt ? { st: L.staffel(this.d.rabatt.staffel), zubehoer: !!this.d.rabatt.zubehoer,
      rundung: this.d.rabatt.rundung || 'position' } : null;
    this.rabattZeilen = el.querySelectorAll('[data-ll-bk-rabattzeile]');
    this.zwischenEl = el.querySelector('[data-ll-bk-zwischensumme]');
    this.rabattEl = el.querySelector('[data-ll-bk-rabatt]');
    this.rabattTextEl = el.querySelector('[data-ll-bk-rabatt-text]');
    this.fussEinzel = el.querySelector('[data-ll-bk-fuss-einzel]');
    this.fussRabatt = el.querySelector('[data-ll-bk-fuss-rabatt]');
    this.rabattAbzug = el.querySelector('[data-ll-bk-rabatt-abzug]');
    this.anreizEl = el.querySelector('[data-ll-bk-anreiz]');
    this.knopf = el.querySelector('[data-ll-bk-knopf]');
    this.meldung = el.querySelector('[data-ll-bk-meldung]');
    this.ansage = el.querySelector('[data-ll-bk-ansage]');
    this.knopfHinweis = el.querySelector('[data-ll-bk-knopf-hinweis]');
    this.abgestelltEl = el.querySelector('[data-ll-bk-abgestellt]');
    this.drawer = document.getElementById(this.d.drawer);
    this.zeilenLesen();
    /* Pruefung 3 (04.10. abends): was schon im Warenkorb liegt, zaehlt fuer die Stufe mit. Start aus Liquid
       (cart.items, keine Anfrage); danach nur cart:change (Inhalt im Ereignis) und cart:refresh/pageshow (je EIN
       Abruf). null = unbekannt -> Rabatt nur aus dem Set, kein Anreiz. */
    this.korb = null;
    this.korbStand = 0;
    this.korbSetzen(Array.isArray(this.d.korb) ? this.d.korb : null, true);
    this.schubladeBauen();
    this.binden();
    this.korbBinden();
    this.leisteMessen();
    if (this.d.vorbelegen) this.vorbelegen(true);
    this.render();
  }

  Baukasten.prototype.geld = function (cent) {
    return L.geld(cent, this.format);
  };

  Baukasten.prototype.zeilenLesen = function () {
    var el = this.el;
    this.vorschau = !!el.querySelector('[data-ll-bk-vorschau]');
    this.allgemein = el.querySelector('[data-ll-bk-allgemein]');
    this.zeilenListe = el.querySelector('[data-ll-bk-zeilen]');
    this.zeilen = Array.prototype.map.call(el.querySelectorAll('[data-ll-bk-zeile]'), function (z) {
      var zustand = z.getAttribute('data-zustand');
      return {
        el: z, sku: z.getAttribute('data-ll-bk-zeile'), rolle: z.getAttribute('data-rolle'), zustand: zustand,
        v: Number(z.getAttribute('data-v')) || null, p: Number(z.getAttribute('data-preis')) || 0,
        n: z.getAttribute('data-name') || '', u: z.getAttribute('data-url') || '',
        eingabe: z.querySelector('[data-ll-bk-menge]'), vorschlag: z.querySelector('[data-ll-bk-vorschlag]'),
        bestellbar: zustand === 'z2', m: 0
      };
    });
    this.offen = this.zeilen.some(function (z) { return z.zustand === 'z1' || z.zustand === 'z2'; });
  };

  Baukasten.prototype.zeile = function (rolle) {
    for (var i = 0; i < this.zeilen.length; i++) if (this.zeilen[i].rolle === rolle) return this.zeilen[i];
    return null;
  };

  Baukasten.prototype.passt = function () {
    return L.kabelPasst(this.st.plaetze, this.d.kabelPasst);
  };

  /* nur mit Katalog zubehoer_vorbelegen = 'ja' (nach RA-Freigabe): Kabel = Zahl der Schirme, Netzteil-Set 1 */
  Baukasten.prototype.vorbelegen = function (start) {
    if (!this.passt() || this.vorschau) return;
    var kabel = this.zeile('kabel');
    if (kabel && kabel.bestellbar && !this.st.kabelManuell) kabel.m = L.belegt(this.st.plaetze);
    var netz = this.zeile('netzteil');
    if (start && netz && netz.bestellbar) netz.m = 1;
  };

  /* ---------------------------------------------------------------- Schublade (Impact x-drawer) */
  Baukasten.prototype.kartePreis = function (s, v) {
    var va = L.variante(s, v);
    if (!va || va.ok === false) return esc(this.t.nichtVerfuegbar || '');
    return this.preisHtml(va.p, va.c);
  };

  /* Preis mit Streichpreis nur bei compare_at > Preis (R5), Klassen und Bildschirmleser-Woerter wie Impacts price-list */
  Baukasten.prototype.preisHtml = function (p, c) {
    var streich = L.streichpreis(p, c), t = this.t;
    if (streich == null) return esc(this.geld(p));
    return '<span class="text-on-sale"><span class="sr-only">' + esc(t.angebot || '') + '</span>' + esc(this.geld(p)) +
      '</span> <s class="ll-bk-streich text-subdued"><span class="sr-only">' + esc(t.regulaer || '') + '</span>' +
      esc(this.geld(streich)) + '</s>';
  };

  Baukasten.prototype.schubladeBauen = function () {
    var dr = this.drawer;
    if (!dr) return;
    var t = this.t, self = this;
    this.titelEl = dr.querySelector('[data-ll-bk-schublade-titel]');
    this.leerenKnopf = dr.querySelector('[data-ll-bk-leeren]');
    this.filterEl = dr.querySelector('[data-ll-bk-filter]');
    var karten = dr.querySelector('[data-ll-bk-karten]');
    this.filterEl.setAttribute('aria-label', t.familie || '');
    var fam = L.familien(this.d.schirme);
    this.filterEl.innerHTML = [''].concat(fam).map(function (f) {
      return '<button type="button" class="ll-bk-chip" data-ll-bk-familie="' + esc(f) + '" aria-pressed="' +
        (f === '' ? 'true' : 'false') + '">' + esc(f === '' ? t.alle : f) + '</button>';
    }).join('');
    if (fam.length < 2) this.filterEl.hidden = true;
    karten.innerHTML = this.d.schirme.map(function (s) {
      var ok = L.schirmOk(s), start = L.startVariante(s);
      var auswahl = '';
      if (L.mehrereVarianten(s)) {
        auswahl = '<select class="ll-bk-karte__variante" data-ll-bk-variante="' + esc(s.h) + '" aria-label="' +
          esc((t.variante || '') + ': ' + s.n) + '"' + (ok ? '' : ' disabled') + '>' + s.vs.map(function (x) {
            return '<option value="' + esc(x.id) + '"' + (Number(x.id) === Number(start) ? ' selected' : '') +
              (x.ok === false ? ' disabled' : '') + '>' + esc(x.t) + '</option>';
          }).join('') + '</select>';
      }
      return '<li class="ll-bk-karten__eintrag" data-familie="' + esc(s.f) + '"><button type="button" class="ll-bk-karte" data-ll-bk-wahl="' +
        esc(s.h) + '" aria-pressed="false"' + (ok ? '' : ' disabled') + '>' + bildHtml(s.b, 360) +
        '<span class="ll-bk-karte__name">' + esc(s.n) + '</span><span class="ll-bk-karte__preis ll-zub-preis" data-ll-bk-kartenpreis>' +
        self.kartePreis(s, start) + '</span><span class="ll-bk-karte__marke">' + esc(t.gewaehlt) + '</span></button>' +
        auswahl + '</li>';
    }).join('');
  };

  Baukasten.prototype.auswahlVon = function (h) {
    var dr = this.drawer;
    var alle = dr ? dr.querySelectorAll('[data-ll-bk-variante]') : [];
    for (var i = 0; i < alle.length; i++) if (alle[i].getAttribute('data-ll-bk-variante') === h) return alle[i];
    return null;
  };

  Baukasten.prototype.karteVon = function (h) {
    var dr = this.drawer;
    var alle = dr ? dr.querySelectorAll('[data-ll-bk-wahl]') : [];
    for (var i = 0; i < alle.length; i++) if (alle[i].getAttribute('data-ll-bk-wahl') === h) return alle[i];
    return null;
  };

  /* Startfokus fuer Impacts initial-focus: gewaehlte Karte, sonst aktiver Filter, sonst erste waehlbare Karte */
  Baukasten.prototype.fokusMarkieren = function () {
    var dr = this.drawer;
    Array.prototype.forEach.call(dr.querySelectorAll('[data-ll-bk-fokus]'), function (k) { k.removeAttribute('data-ll-bk-fokus'); });
    var ziel = dr.querySelector('[data-ll-bk-wahl][aria-pressed="true"]');
    if (!sichtbar(ziel)) ziel = this.filterEl && !this.filterEl.hidden ? this.filterEl.querySelector('[aria-pressed="true"]') : null;
    if (!sichtbar(ziel)) {
      ziel = null;
      var karten = dr.querySelectorAll('[data-ll-bk-wahl]');
      for (var i = 0; i < karten.length && !ziel; i++) if (sichtbar(karten[i])) ziel = karten[i];
    }
    (ziel || this.titelEl || dr).setAttribute('data-ll-bk-fokus', '');
  };

  Baukasten.prototype.schubladeOeffnen = function (i) {
    var dr = this.drawer;
    if (!dr || typeof dr.show !== 'function') return;
    this.st.platz = i;
    var ausloeser = this.plan.querySelector('[data-ll-bk-platz="' + i + '"]');
    if (ausloeser) ausloeser.classList.add('ist-aktiv');
    var e = this.st.plaetze[i] || null;
    var h = L.handleVon(e);
    if (this.titelEl) {
      this.titelEl.textContent = i >= this.st.plaetze.length ? this.t.hinzu : L.text(this.t.schublade, { n: i + 1 });
    }
    Array.prototype.forEach.call(dr.querySelectorAll('[data-ll-bk-wahl]'), function (k) {
      k.setAttribute('aria-pressed', k.getAttribute('data-ll-bk-wahl') === h ? 'true' : 'false');
    });
    if (h && e && e.v != null) {
      var sel = this.auswahlVon(h);
      if (sel) {
        sel.value = String(e.v);
        this.kartenpreisSetzen(h);
      }
    }
    if (this.leerenKnopf) this.leerenKnopf.hidden = !h;
    this.filtern(this.st.filter);
    this.fokusMarkieren();
    dr.show();
  };

  Baukasten.prototype.kartenpreisSetzen = function (h) {
    var s = L.finde(this.d.schirme, h), sel = this.auswahlVon(h), karte = this.karteVon(h);
    if (!s || !karte) return;
    var preis = karte.querySelector('[data-ll-bk-kartenpreis]');
    if (preis) preis.innerHTML = this.kartePreis(s, sel ? Number(sel.value) : L.startVariante(s));
  };

  Baukasten.prototype.filtern = function (f) {
    this.st.filter = f || '';
    var dr = this.drawer;
    Array.prototype.forEach.call(dr.querySelectorAll('[data-ll-bk-familie]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ll-bk-familie') === (f || '') ? 'true' : 'false');
    });
    Array.prototype.forEach.call(dr.querySelectorAll('.ll-bk-karten__eintrag'), function (li) {
      li.hidden = !!f && li.getAttribute('data-familie') !== f;
    });
  };

  /* ziel: Platz-Index oder 'hinzu' (ohne Angabe: der Platz, fuer den die Schublade offen war) */
  Baukasten.prototype.schubladeSchliessen = function (ziel) {
    var self = this, i = ziel == null ? this.st.platz : ziel, dr = this.drawer;
    var fertig = dr && typeof dr.hide === 'function' ? dr.hide() : null;
    Promise.resolve(fertig).then(function () {
      setTimeout(function () { self.fokusPlatz(i); }, 0);
    });
  };

  Baukasten.prototype.fokusPlatz = function (i) {
    var k = i === 'hinzu' ? null : this.plan.querySelector('[data-ll-bk-platz="' + i + '"]');
    k = k || this.plan.querySelector('[data-ll-bk-hinzu]') || this.plan.querySelector('[data-ll-bk-platz]');
    if (k) k.focus();
  };

  /* erst schliessen (open faellt sofort weg), dann neu zeichnen — sonst bliebe der Amber-Ring am Platz haengen */
  Baukasten.prototype.waehlen = function (h) {
    var st = this.st, i = st.platz;
    var s = L.finde(this.d.schirme, h);
    if (!s || !L.schirmOk(s)) return;
    var sel = this.auswahlVon(h);
    var v = sel ? Number(sel.value) : L.startVariante(s);
    var va = L.variante(s, v);
    if (!va || va.ok === false) return;
    var eintrag = { h: h, v: va.id };
    if (i >= st.plaetze.length) st.plaetze.push(eintrag);
    else st.plaetze[i] = eintrag;
    this.schubladeSchliessen();
    this.nachSchirmen();
  };

  /* "Platz leeren" in der Schublade */
  Baukasten.prototype.leeren = function () {
    this.entfernen(this.st.platz, true);
  };

  /* Schirm von Platz i entfernen (Knopf x am Platz oder "Platz leeren"): neu zeichnen (Summe, Belegung, Positionen),
     ansagen, Fokus auf den nun leeren Platz bzw. "Schirm hinzufuegen" */
  Baukasten.prototype.entfernen = function (i, ausSchublade) {
    var st = this.st, e = st.plaetze[i];
    if (!e) { if (ausSchublade) this.schubladeSchliessen(); return; }
    var name = this.platzName(e), mitBaldachin = !!st.baldachin;
    st.plaetze = L.platzEntfernen(st.plaetze, i, mitBaldachin);
    var ziel = L.fokusNachEntfernen(mitBaldachin, i);
    if (this.meldung) this.meldung.textContent = '';
    if (ausSchublade) this.schubladeSchliessen(ziel);
    this.nachSchirmen();
    if (!ausSchublade) this.fokusPlatz(ziel);
    this.ansagen(L.text(this.t.entferntPlatz, { name: name, n: i + 1 }));
  };

  /* Live-Region: erst leeren, dann setzen — die gleiche Meldung zweimal hintereinander wird sonst nicht gelesen */
  Baukasten.prototype.ansagen = function (text) {
    var a = this.ansage;
    if (!a) return;
    a.textContent = '';
    setTimeout(function () { a.textContent = text; }, 60);
  };

  Baukasten.prototype.nachSchirmen = function () {
    if (this.d.vorbelegen) this.vorbelegen(false);
    this.render();
  };

  /* Baldachin wechseln: verlustfrei (L.baldachinWechsel). Was nicht auf die Auslaesse passt, bleibt abgestellt und
     steht mit Namen im Hinweis direkt unter der Radiogruppe (role=status), bis es wieder eingesetzt ist. */
  Baukasten.prototype.baldachinSetzen = function (h) {
    var self = this, b = h ? L.finde(this.d.baldachine, h) : null;
    var r = L.baldachinWechsel(this.st.plaetze, this.st.abgestellt, b ? b.a : null, this.d.maxFrei || 12);
    this.st.baldachin = b ? b.h : null;
    this.st.plaetze = r.plaetze;
    this.st.abgestellt = r.abgestellt;
    if (this.meldung) this.meldung.textContent = '';
    Array.prototype.forEach.call(this.el.querySelectorAll('.ll-bk-option'), function (o) {
      var w = o.querySelector('[data-ll-bk-baldachin]');
      o.classList.toggle('ist-gewaehlt', !!w && w.checked);
    });
    this.nachSchirmen();
    if (r.neu.length) this.abgestelltZeigen();
    if (r.wieder.length) this.ansagen(L.text(this.t.wiederDa, { namen: self.namen(r.wieder) }));
  };

  Baukasten.prototype.namen = function (eintraege) {
    var self = this;
    return L.namenListe(eintraege, function (e) { return self.platzName(e); });
  };

  /* Hinweis "nicht im Set" — bleibt stehen, bis alle abgestellten Schirme wieder auf einem Platz sind */
  Baukasten.prototype.renderAbgestellt = function () {
    var el = this.abgestelltEl;
    if (!el) return;
    var text = this.st.abgestellt.length ? L.text(this.t.abgestellt, { namen: this.namen(this.st.abgestellt) }) : '';
    if (el.textContent !== text) el.textContent = text;
  };

  /* Impact 'variant:change' (bubbelt vom Kaufformular): nur Varianten DIESES Schirms, sonst nichts */
  Baukasten.prototype.varianteGewechselt = function (id) {
    var s = L.finde(this.d.schirme, this.d.aktuell);
    if (!s || !L.variante(s, id) || Number(id) === Number(this.aktuellV)) return;
    var alt = this.aktuellV;
    this.aktuellV = Number(id);
    this.st.plaetze = L.varianteTauschen(this.st.plaetze, s.h, alt, this.aktuellV);
    this.st.abgestellt = L.varianteTauschen(this.st.abgestellt, s.h, alt, this.aktuellV);
    this.render();
  };

  /* Befund MITTEL 04.10. (WCAG 2.4.11): Impacts feste Kaufleiste (product-quick-add, unten) verdeckte Fokusziele.
     --ll-leiste = hoechste feste Ueberdeckung am unteren Rand: Kaufleiste (Hoehe + Abstand nach unten, ohne ihre
     Einblend-Verschiebung) bzw. das Chat-Symbol von Shopify Inbox (geschlossener Shadow-DOM, nicht messbar; gemessen
     04.10.: 88 px ueber dem Rand, 50 px hoch, unten rechts — im Prueflauf lag Platz 2 mobil darunter). Das CSS gibt
     jedem Fokusziel und dem Hinweis "nicht im Set" so viel scroll-margin-block-end (ohne Skript 9rem). */
  var CHAT_UNTEN = 140;

  Baukasten.prototype.leisteMessen = function () {
    var el = this.el;
    function messen() {
      var leiste = document.querySelector('product-quick-add');
      var unten = 0;
      if (leiste && leiste.offsetHeight) {
        unten = leiste.offsetHeight + (parseFloat(window.getComputedStyle(leiste).bottom) || 0);
      }
      if (document.querySelector('shopify-chat')) unten = Math.max(unten, CHAT_UNTEN);
      el.style.setProperty('--ll-leiste', Math.ceil(unten) + 'px');
    }
    messen();
    window.addEventListener('resize', messen);
    var leiste = document.querySelector('product-quick-add');
    if (leiste && window.ResizeObserver) new ResizeObserver(messen).observe(leiste);
  };

  /* Hinweis "nicht im Set" ins Bild holen, wenn gerade Schirme abgestellt wurden (nur so weit wie noetig; die
     Radiogruppe mit dem Fokus steht direkt darueber und bleibt sichtbar) */
  Baukasten.prototype.abgestelltZeigen = function () {
    var el = this.abgestelltEl;
    if (!el || typeof el.scrollIntoView !== 'function') return;
    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ block: 'nearest', behavior: ruhig ? 'auto' : 'smooth' });
  };

  /* ---------------------------------------------------------------- Ereignisse */
  Baukasten.prototype.binden = function () {
    var self = this, el = this.el;
    el.addEventListener('change', function (e) {
      var w = e.target.closest('[data-ll-bk-baldachin]');
      if (w) { self.baldachinSetzen(w.value); return; }
      var m = e.target.closest('[data-ll-bk-menge]');
      if (m) self.mengeSetzen(m.closest('[data-ll-bk-zeile]'), L.menge(m.value));
    });
    el.addEventListener('input', function (e) {
      var m = e.target.closest('[data-ll-bk-menge]');
      if (m && m.value !== '') self.mengeSetzen(m.closest('[data-ll-bk-zeile]'), L.menge(m.value), true);
    });
    el.addEventListener('click', function (e) {
      var x = e.target.closest('[data-ll-bk-entfernen]');
      if (x) { self.entfernen(Number(x.getAttribute('data-ll-bk-entfernen'))); return; }
      var p = e.target.closest('[data-ll-bk-platz]');
      if (p) { self.schubladeOeffnen(Number(p.getAttribute('data-ll-bk-platz'))); return; }
      if (e.target.closest('[data-ll-bk-hinzu]')) { self.schubladeOeffnen(self.st.plaetze.length); return; }
      var minus = e.target.closest('[data-ll-bk-minus]'), plus = e.target.closest('[data-ll-bk-plus]');
      if (minus || plus) {
        var z = (minus || plus).closest('[data-ll-bk-zeile]');
        var akt = self.zeileVon(z);
        if (akt) self.mengeSetzen(z, akt.m + (plus ? 1 : -1));
        return;
      }
      if (e.target.closest('[data-ll-bk-vorschlag]')) {
        var kabel = self.zeile('kabel');
        if (kabel) { self.st.kabelManuell = true; kabel.m = L.belegt(self.st.plaetze); self.render(); }
        return;
      }
      if (e.target.closest('[data-ll-bk-knopf]')) self.inDenWarenkorb();
    });
    if (this.drawer) {
      this.drawer.addEventListener('dialog:after-hide', function () {
        Array.prototype.forEach.call(self.plan.querySelectorAll('.ist-aktiv'), function (k) { k.classList.remove('ist-aktiv'); });
      });
      this.drawer.addEventListener('click', function (e) {
        var w = e.target.closest('[data-ll-bk-wahl]');
        if (w) { if (!w.disabled) self.waehlen(w.getAttribute('data-ll-bk-wahl')); return; }
        var f = e.target.closest('[data-ll-bk-familie]');
        if (f) { self.filtern(f.getAttribute('data-ll-bk-familie')); return; }
        if (e.target.closest('[data-ll-bk-leeren]')) self.leeren();
      });
      this.drawer.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-ll-bk-variante]');
        if (sel) self.kartenpreisSetzen(sel.getAttribute('data-ll-bk-variante'));
      });
    }
    document.addEventListener('lunalume:vorschau', function () { self.zeilenLesen(); self.render(); });
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.id) self.varianteGewechselt(Number(v.id));
    });
  };

  Baukasten.prototype.zeileVon = function (el) {
    for (var i = 0; i < this.zeilen.length; i++) if (this.zeilen[i].el === el) return this.zeilen[i];
    return null;
  };

  Baukasten.prototype.mengeSetzen = function (el, wert, still) {
    var z = this.zeileVon(el);
    if (!z || !z.bestellbar) return;
    z.m = L.menge(wert);
    if (z.rolle === 'kabel') this.st.kabelManuell = true;
    this.render(still);
  };

  /* ---------------------------------------------------------------- Darstellung */
  Baukasten.prototype.platzName = function (e) {
    var s = e ? L.finde(this.d.schirme, L.handleVon(e)) : null;
    if (!s) return '';
    var va = L.variante(s, e.v == null ? s.v : e.v);
    return s.n + (L.mehrereVarianten(s) && va && va.t ? ' · ' + va.t : '');
  };

  Baukasten.prototype.platzKnopf = function (e, i) {
    var t = this.t, nr = i + 1;
    var s = e ? L.finde(this.d.schirme, L.handleVon(e)) : null;
    var aktiv = this.drawer && this.drawer.hasAttribute('open') && this.st.platz === i ? ' ist-aktiv' : '';
    if (!s) {
      return '<button type="button" class="ll-bk-platz ll-bk-platz--frei' + aktiv + '" data-ll-bk-platz="' + i +
        '" aria-haspopup="dialog" aria-label="' + esc(L.text(t.platzFrei, { n: nr })) +
        '"><span class="ll-bk-platz__plus" aria-hidden="true"></span>' +
        '<span class="ll-bk-platz__nr" aria-hidden="true">' + nr + '</span></button>';
    }
    var va = L.variante(s, e.v == null ? s.v : e.v);
    var ok = !!va && va.ok !== false;
    var name = this.platzName(e);
    var label = L.text(t.platzVoll, { n: nr, name: name }) + (ok ? '' : ' (' + (t.nichtVerfuegbar || '') + ')');
    return '<button type="button" class="ll-bk-platz ll-bk-platz--voll' + (ok ? '' : ' ll-bk-platz--nv') + aktiv +
      '" data-ll-bk-platz="' + i + '" aria-haspopup="dialog" aria-label="' + esc(label) + '">' + bildHtml(s.b, 360) +
      '<span class="ll-bk-platz__nr" aria-hidden="true">' + nr + '</span></button>' +
      '<button type="button" class="ll-bk-entfernen" data-ll-bk-entfernen="' + i + '" aria-label="' +
      esc(L.text(t.entfernen, { n: nr })) + '">' + X_SVG + '</button>' +
      '<span class="ll-bk-platz__name" aria-hidden="true">' + esc(name) + '</span>';
  };

  Baukasten.prototype.renderPlan = function () {
    var st = this.st, d = this.d, t = this.t, self = this;
    var aktiv = document.activeElement;
    var fokus = null;
    if (aktiv && this.plan.contains(aktiv)) {
      if (aktiv.hasAttribute('data-ll-bk-hinzu')) fokus = '[data-ll-bk-hinzu]';
      else if (aktiv.hasAttribute('data-ll-bk-entfernen')) fokus = '[data-ll-bk-entfernen="' + aktiv.getAttribute('data-ll-bk-entfernen') + '"]';
      else if (aktiv.hasAttribute('data-ll-bk-platz')) fokus = '[data-ll-bk-platz="' + aktiv.getAttribute('data-ll-bk-platz') + '"]';
    }
    var b = st.baldachin ? L.finde(d.baldachine, st.baldachin) : null;
    var html = '';
    if (b) {
      var pkt = L.punkte(b.a);
      html = '<div class="ll-bk-teller" style="--ll-platz:' + (PLATZ_GROESSE[b.a] || 17) + '%">' +
        '<span class="ll-bk-teller__ring" aria-hidden="true"></span><ul class="ll-bk-teller__plaetze">' +
        st.plaetze.map(function (e, i) {
          return '<li class="ll-bk-teller__platz" style="--x:' + pkt[i].x + '%;--y:' + pkt[i].y + '%">' + self.platzKnopf(e, i) + '</li>';
        }).join('') + '</ul></div>';
    } else {
      html = '<ul class="ll-bk-reihe">' + st.plaetze.map(function (e, i) {
        return '<li class="ll-bk-reihe__platz">' + self.platzKnopf(e, i) + '</li>';
      }).join('');
      if (st.plaetze.length < (d.maxFrei || 12)) {
        html += '<li class="ll-bk-reihe__platz"><button type="button" class="ll-bk-platz ll-bk-platz--neu" data-ll-bk-hinzu aria-haspopup="dialog">' +
          '<span class="ll-bk-platz__plus" aria-hidden="true"></span></button><span class="ll-bk-platz__name">' + esc(t.hinzu) + '</span></li>';
      }
      html += '</ul>';
    }
    this.plan.setAttribute('data-modus', b ? 'baldachin' : 'frei');
    this.plan.innerHTML = html;
    if (fokus !== null) {
      var k = this.plan.querySelector(fokus);
      if (k) k.focus();
    }
    if (this.zaehler) {
      this.zaehler.textContent = b
        ? L.text(t.belegung, { belegt: L.belegt(st.plaetze), plaetze: b.a })
        : L.text(t.belegungFrei, { belegt: L.belegt(st.plaetze) });
    }
  };

  Baukasten.prototype.renderZeilen = function (still) {
    var passt = this.passt(), vorschau = this.vorschau, t = this.t;
    var zeigen = !this.offen || vorschau || passt;
    if (this.zeilenListe) this.zeilenListe.hidden = !zeigen;
    if (this.allgemein) this.allgemein.hidden = zeigen;
    var anzahl = L.belegt(this.st.plaetze);
    this.zeilen.forEach(function (z) {
      if (!zeigen) z.m = 0;
      if (z.eingabe && !still) z.eingabe.value = String(z.m);
      if (z.vorschlag) {
        var sichtbar = (z.bestellbar || vorschau) && zeigen && anzahl > 0 && z.m !== anzahl;
        z.vorschlag.hidden = !sichtbar;
        z.vorschlag.textContent = L.text(t.vorschlag, { n: anzahl });
      }
    });
  };

  Baukasten.prototype.renderListe = function () {
    var self = this, t = this.t;
    var pos = L.positionen(this.st, this.d, this.zeilen);
    if (!pos.length) {
      this.liste.innerHTML = '<li class="ll-bk-pos ll-bk-pos--leer">' + esc(t.leer) + '</li>';
    } else {
      this.liste.innerHTML = pos.map(function (p) {
        var name = '<a href="' + esc(p.u) + '" class="ll-bk-pos__link">' + esc(p.n) + '</a>';
        if (p.ok === false) {
          return '<li class="ll-bk-pos ll-bk-pos--nv"><span class="ll-bk-pos__name">' + name +
            (p.m > 1 ? '<span class="ll-bk-pos__menge">' + p.m + ' ×</span>' : '') + '</span>' +
            '<span class="ll-bk-pos__preis">' + esc(t.nichtVerfuegbar || '') + '</span></li>';
        }
        return '<li class="ll-bk-pos"><span class="ll-bk-pos__name">' + name +
          (p.m > 1 ? '<span class="ll-bk-pos__menge">' + p.m + ' × ' + esc(self.geld(p.p)) + '</span>' : '') + '</span>' +
          '<span class="ll-bk-pos__preis ll-zub-preis">' + esc(self.geld(p.p * p.m)) + '</span></li>';
      }).join('');
    }
    this.renderSumme(pos);
    this.knopfSetzen(pos);
  };

  /* ---------------------------------------------------------------- Warenkorb-Inhalt fuer die Staffel */
  /* items = [{h, m}] bzw. cart.js-Zeilen, null = unbekannt. still: nicht neu zeichnen (Start, render() folgt) */
  Baukasten.prototype.korbSetzen = function (items, still) {
    var urls = (this.zeilen || []).map(function (z) { return z.u; });
    this.korb = Array.isArray(items)
      ? L.korbZaehlen(items, L.rabattHandles(this.d, !!(this.rabatt && this.rabatt.zubehoer), urls)) : null;
    this.korbStand++;
    if (!still) this.renderSumme(L.positionen(this.st, this.d, this.zeilen));
  };

  /* Ein Abruf von cart.js; eine inzwischen per cart:change gemeldete neuere Fassung wird nicht ueberschrieben */
  Baukasten.prototype.korbNeu = function () {
    var self = this, stand = this.korbStand;
    korbLesen().then(function (korb) {
      if (self.korbStand === stand) self.korbSetzen(korb ? korb.items : null);
    });
  };

  Baukasten.prototype.korbBinden = function () {
    var self = this;
    document.addEventListener('cart:change', function (e) {
      var korb = e.detail && e.detail.cart;
      if (korb && Array.isArray(korb.items)) self.korbSetzen(korb.items);
    });
    document.addEventListener('cart:refresh', function () { self.korbNeu(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.korbNeu(); });
  };

  /* Summe, bei erreichter Staffel Zwischensumme + "Mengenrabatt (n Artikel · p %)" + Summe = Endbetrag (R5). Liegen
     schon Schirme/Baldachine im Warenkorb, gilt die Stufe fuer Set + Warenkorb ("n Artikel inkl. k im Warenkorb"),
     der Abzug ist der Anteil des Sets (Pruefung 3, 04.10. abends). Der Anreiz nennt nur die echte naechste Stufe und
     nur, wenn die freien Plaetze dafuer reichen; Warenkorb unbekannt -> kein Anreiz; fremde Artikel im Warenkorb
     (Regel nicht lesbar) -> statt des Anreizes der Hinweis, dass sie nicht eingerechnet sind. */
  Baukasten.prototype.renderSumme = function (pos) {
    var t = this.t, st = this.st, d = this.d, k = this.korb;
    var r = this.rabatt ? L.mengenrabatt(pos, this.rabatt.st, {
      zubehoer: this.rabatt.zubehoer, rundung: this.rabatt.rundung, korb: k ? k.set : 0
    }) : null;
    var mit = !!(r && r.stufe && r.betrag > 0);
    var neu = this.geld(r ? r.summe : L.summe(pos));
    if (this.summeEl.textContent !== neu) this.summeEl.textContent = neu;
    Array.prototype.forEach.call(this.rabattZeilen, function (z) { z.hidden = !mit; });
    if (mit) {
      var zw = this.geld(r.zwischensumme), ab = '\u2212' + this.geld(r.betrag);
      var text = r.korb > 0
        ? L.text(t.rabattPostenKorb, { n: r.gesamt, k: r.korb, p: L.prozentText(r.stufe.p) })
        : L.text(t.rabattPosten, { n: r.anzahl, p: L.prozentText(r.stufe.p) });
      if (this.zwischenEl && this.zwischenEl.textContent !== zw) this.zwischenEl.textContent = zw;
      if (this.rabattEl && this.rabattEl.textContent !== ab) this.rabattEl.textContent = ab;
      if (this.rabattTextEl && this.rabattTextEl.textContent !== text) this.rabattTextEl.textContent = text;
    }
    if (this.fussEinzel) this.fussEinzel.hidden = mit;
    if (this.fussRabatt) this.fussRabatt.hidden = !mit;
    if (this.rabattAbzug) this.rabattAbzug.hidden = !mit;
    if (this.anreizEl) {
      var anreiz = '';
      if (r && r.anzahl > 0 && k && k.fremd > 0) {
        anreiz = t.korbFremd || '';
      } else if (r && r.anzahl > 0 && k) {
        var n = r.naechste, b = st.baldachin ? L.finde(d.baldachine, st.baldachin) : null;
        var frei = (b ? b.a : (d.maxFrei || 12)) - L.belegt(st.plaetze);
        if (n && n.fehlt <= frei) {
          var vorlage = r.korb > 0 ? (n.fehlt === 1 ? t.rabattAnreizKorb1 : t.rabattAnreizKorbN)
            : (n.fehlt === 1 ? t.rabattAnreiz1 : t.rabattAnreizN);
          anreiz = L.text(vorlage, { n: n.fehlt, p: L.prozentText(n.p) });
        }
      }
      if (this.anreizEl.textContent !== anreiz) this.anreizEl.textContent = anreiz;
      this.anreizEl.hidden = !anreiz;
    }
  };

  /* Leeres Set: Knopf deaktiviert, Hinweis sichtbar und per aria-describedby am Knopf. Waehrend der Anfrage bleibt
     der Knopf fokussierbar (aria-disabled + aria-busy statt disabled, Befund MITTEL 04.10.) */
  Baukasten.prototype.knopfSetzen = function (pos) {
    var leer = L.setLeer(pos);
    if (this.knopf.getAttribute('aria-busy') !== 'true') this.knopf.disabled = leer;
    if (this.knopfHinweis) {
      this.knopfHinweis.hidden = !leer;
      if (leer) this.knopf.setAttribute('aria-describedby', this.knopfHinweis.id);
      else this.knopf.removeAttribute('aria-describedby');
    }
  };

  Baukasten.prototype.render = function (still) {
    this.renderPlan();
    this.renderAbgestellt();
    this.renderZeilen(still);
    this.renderListe();
  };

  /* ---------------------------------------------------------------- Warenkorb */
  /* Fokus zurueck auf den Knopf, falls er unterwegs verloren ging (z. B. auf BODY) — vor dem Schubfach, damit
     Impacts Fokusfalle den Knopf als Rueckgabeziel merkt, und nach einem Fehler (WCAG 2.4.3, Befund MITTEL 04.10.) */
  Baukasten.prototype.knopfFokus = function () {
    var a = document.activeElement;
    if (!a || a === document.body || a === document.documentElement) this.knopf.focus({ preventScroll: true });
  };

  Baukasten.prototype.inDenWarenkorb = function () {
    var self = this, t = this.t, knopf = this.knopf;
    var items = L.posten(L.positionen(this.st, this.d, this.zeilen));
    if (!items.length || knopf.getAttribute('aria-busy') === 'true') return;
    var wurzel = wurzelPfad();
    var abschnitte = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: abschnitte }
    }));
    /* nicht disabled: Chrome nimmt einem fokussierten, deaktivierten Knopf den Fokus (danach BODY) */
    knopf.setAttribute('aria-disabled', 'true');
    knopf.setAttribute('aria-busy', 'true');
    this.meldung.textContent = '';
    var koerper = { items: items };
    if (abschnitte.length) koerper.sections = abschnitte.join(',');
    fetch(wurzel + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(koerper)
    }).then(function (antwort) {
      return antwort.json().catch(function () { return {}; }).then(function (json) {
        if (!antwort.ok) {
          var fehler = new Error('cart/add ' + antwort.status);
          fehler.status = antwort.status;
          throw fehler;
        }
        return json;
      });
    }).then(function (json) {
      var tv = (window.themeVariables && window.themeVariables.settings) || {};
      if (tv.cartType === 'page') {
        window.location.href = wurzel + 'cart';
        return null;
      }
      /* add.js war erfolgreich = das Set liegt im Warenkorb -> immer "Im Warenkorb." (Pruefung 3, Befund MITTEL:
         ein 429 auf cart.js zeigte "Das hat nicht geklappt", ein zweiter Klick verdoppelte das Set). cart.js ist nur
         Zusatz fuer Schubfach und Zaehler; ohne Warenkorb (429/HTML) cart:refresh als Rueckfall, Schubfach trotzdem auf. */
      self.meldung.textContent = t.ok;
      return self.nachDemHinzufuegen(json, abschnitte).catch(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    }).catch(function (fehler) {
      self.meldung.textContent = fehler && fehler.status === 422 ? t.fehler422 : t.fehler;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      self.knopfFokus();
    }).then(function () {
      knopf.removeAttribute('aria-busy');
      knopf.removeAttribute('aria-disabled');
      self.knopfSetzen(L.positionen(self.st, self.d, self.zeilen));
    });
  };

  /* Nach erfolgreichem add.js: Warenkorb einmal lesen (r.ok geprueft, korbLesen wirft nie). Mit Warenkorb und
     gebuendelten Abschnitten cart:change wie Impacts product-form (Schubfach + Zaehler sofort, aktualisiert auch die
     Staffel hier), sonst cart:refresh. Danach product:added-to-cart (Mengenleiste) und das Schubfach. */
  Baukasten.prototype.nachDemHinzufuegen = function (json, abschnitte) {
    var self = this;
    return korbLesen(true).then(function (korb) {
      var gebuendelt = json && json.sections && abschnitte.length && abschnitte.every(function (s) { return json.sections[s]; });
      if (korb && gebuendelt) {
        korb.sections = json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true, detail: { baseEvent: 'variant:add', cart: korb }
        }));
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      document.dispatchEvent(new CustomEvent('product:added-to-cart'));
      var schubfach = document.getElementById('cart-drawer');
      if (schubfach && typeof schubfach.show === 'function') {
        self.knopfFokus();
        schubfach.show();
      }
    });
  };

  /* ---------------------------------------------------------------- Start */
  function starten(wurzel) {
    Array.prototype.forEach.call((wurzel || document).querySelectorAll('[data-ll-bk]'), function (el) {
      if (el.llBaukasten) return;
      try {
        el.llBaukasten = new Baukasten(el);
      } catch (fehler) {
        if (window.console) console.error('lunalume-set', fehler);
      }
    });
  }

  /* Einladungszeile: ruhig zum Baukasten, Fokus auf dessen Ueberschrift */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ll-einladung]');
    if (!a) return;
    var ziel = document.getElementById('lunalume-set-baukasten');
    if (!ziel) return;
    e.preventDefault();
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    var h = ziel.querySelector('h2[tabindex]');
    if (h) h.focus({ preventScroll: true });
  });

  document.addEventListener('shopify:section:load', function (e) { starten(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { starten(document); });
  } else {
    starten(document);
  }
})();
